// AI-Generated Code - 2026-03 - Placeholder for commercial release

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "wouter";

export default function TermsPage() {
  return (
    <div className="container max-w-3xl mx-auto py-10 px-4">
      <Card>
        <CardHeader>
          <CardTitle>Terms of Service</CardTitle>
          <p className="text-sm text-muted-foreground">
            Last updated: {new Date().toISOString().split("T")[0]}
          </p>
        </CardHeader>
        <CardContent className="prose prose-slate dark:prose-invert max-w-none">
          <p className="text-muted-foreground">
            This is a placeholder. Before commercial release, replace this page with your full Terms of Service drafted or reviewed by a lawyer.
          </p>
          <p className="text-muted-foreground mt-4">
            Typical sections include: acceptance of terms, description of service, user obligations, acceptable use, payment and subscription terms, intellectual property, limitation of liability, indemnification, termination, governing law, and contact information.
          </p>
          <Link href="/">
            <span className="text-primary hover:underline mt-6 inline-block">← Back to home</span>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
